import { useRoomCalendar } from "@website/accommodation-ui/hotel-reserve-rooms-layout/hotel-reserve-card/hotel-room-calendar/hotel-room-calendar.hook";
import { HotelRoomCalendarPropertiesType } from "@website/accommodation-ui/hotel-reserve-rooms-layout/hotel-reserve-card/hotel-room-calendar/hotel-room-calendar.types";
import { Datepicker } from "@website/ui/datepicker";
import { deepCompare } from "@website/utils/deep-compare";
import { FC, memo } from "react";

const Component: FC<HotelRoomCalendarPropertiesType> = (properties) => {
  const {
    selectedDate,
    setSelectedDate,
    calendarData,
    disableLimit,
    onCalendarChange,
    suggestions,
    isLabelToTop
  } = useRoomCalendar(properties);
  const { view = "default" } = properties;
  return (
    <div className="md:p-3" id="hotel_calendar">
      <Datepicker
        calendarData={calendarData}
        disableLimit={disableLimit}
        mode="range"
        onChange={onCalendarChange}
        setValue={setSelectedDate}
        suggestions={suggestions}
        type="flat"
        value={selectedDate}
        view={view}
        isLabelTop={isLabelToTop}
      />
    </div>
  );
};

export const HotelRoomCalendar = memo(Component, deepCompare);
